@if (!inputService.hidden && inputService.formInputDefinition && inputService.control) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field [appearance]='inputService.inputConfig.appearence' [floatLabel]='inputService.formInputDefinition.placeholder ? "always" : "auto"'>
      <mat-label>
        @if (inputService.exportEAgency) {
          <img matTooltip='Esportato in eAgency' class='title-input-eagency' src='assets/images/logos/logo_eagency.png'/>
        }
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      <input
        [required]='inputService.inputConfig.required'
        [readonly]='inputService.inputConfig.readOnly'
        [name]='inputService.formControlKey'
        [autocomplete]="'nope_' + inputService.formControlKey"
        type='number'
        matInput
        [placeholder]="(inputService.inputConfig.placeholder || '') | translate"
        [formControlName]='inputService.formControlKey'>
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint}}</mat-hint>
      }
      @if (inputService.control.value !== null && !inputService.inputConfig.readOnly && inputService.inputConfig.clearable) {
        <mat-icon matSuffix style='cursor: pointer;' (click)='inputService.control.setValue(null)'>close</mat-icon>
      }
      @if (!inputService.control.valid && inputService.errorMessage) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}